import { render, staticRenderFns } from "./ContactUsDialog.vue?vue&type=template&id=51fdbbf2&scoped=true&"
import script from "./ContactUsDialog.vue?vue&type=script&lang=js&"
export * from "./ContactUsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsDialog.vue?vue&type=style&index=0&id=51fdbbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../applauncher/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fdbbf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../applauncher/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
